module.exports = __webpack_public_path__ + "img/arrow_downward.102a8c33.svg";